export default "__VITE_ASSET__BdOvqxpG__"